module.exports = __webpack_public_path__ + "static/media/S37_B.681a883d.png";